module.exports = __webpack_public_path__ + "static/media/roble_newyork.bd96baa0.jpg";